import { useCallback } from 'react';
import { debounce } from 'lodash';

import { TextFieldQldDS } from '@/components';

interface DebouncedInputProps {
	value: string | undefined;
	handleChange: (value: string | number) => void;
	debounceTimer?: number;
	customStyles?: string;
}

export const DebouncedInput = ({
	value,
	debounceTimer = 50,
	handleChange,
	customStyles,
}: DebouncedInputProps) => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedFn = useCallback(debounce(handleChange, debounceTimer), []);

	return (
		<TextFieldQldDS
			customStyles={customStyles}
			type="text"
			placeholder="Search"
			defaultValue={value}
			size="fixedWidth6"
			handleChange={e => debouncedFn(e.target.value)}
		/>
	);
};
